import HeroSection from "../components/HeroSection";
import ReviewsSection from "../components/ReviewsSection";
import ContactSection from "../components/ContactSection";
import ReservationAboutSection from "./ReservationAboutSection";
import ImagePage from "./ImagePage"
import Wave from "./Wave"
import CateringCTASection from "./CateringCTASection";
import OfertaSection from "./OfertaSection";
import GaleriaSection from "./GaleriaSection";

export default function HomePage() {
  return (
    <div className="font-sans bg-light2">
      <main>
        <HeroSection />
        <ReservationAboutSection />
        <ImagePage />
        <OfertaSection />
        <CateringCTASection />
        <Wave />
        <ReviewsSection />
        <GaleriaSection />
        <ContactSection />

      </main>
    </div>
  );
}
